import style from './block.module.scss';
import clsx from 'clsx';
import { ReactComponent as BurgerCross } from './burgerCross.svg';
import { ReactComponent as Logo } from '../logo.svg';
import { Socials } from '../Socials/block';
import { Nav } from '../Nav/block';

export const MobileMenu = ({ open, menu, closeFunction, links, practices }) => {
    const menuClass = clsx({
        [style.menu]: true,
        [style.open]: open,
    });

    return (
        <div className={menuClass}>
            <div className={style.row1}>
                <span className={style.circle} onClick={closeFunction}>
                    <BurgerCross />
                </span>
                <div>
                    <a href="/">
                        <Logo />
                    </a>
                </div>
            </div>
            <div className={style.row2}>
                <Nav menu={menu} practices={practices} />
            </div>
            <div className={style.row3}>
                <span>Suivez-nous</span>
                <div className={style.separator} />
                <Socials links={links} />
            </div>
        </div>
    );
};
